import * as React from 'react';
import { useLocation } from 'umi';

import Ready from './Ready';
import rootStore from '@/models';
import './index.less';

interface ReadyProps {}

const Index: React.FC<ReadyProps> = () => {
  // @ts-ignore
  const { query } = useLocation();

  React.useEffect(() => {
    const { source } = query || {};
    rootStore.common.setSource(source);
    // @ts-ignore
  }, [query]);
  return <Ready />;
};

export default Index;
